import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import IframeResizer from 'iframe-resizer-react';

type ContactDialogProps = {
    show: boolean;
    onClose: () => void;
};

export const ContactDialog = ({ show, onClose }: ContactDialogProps) => {
    const dialogTrackingKey = 'ordercom.contact-dialog';
    return (
        <Dialog
            title={'Contact'}
            show={show}
            showCloseButton={false}
            onClose={onClose}
            useOverflow
            bodyClassName={'min-height-500'}
            headerButtons={
                <Button
                    bsStyle={Button.MUTED}
                    iconOnly
                    iconName='rioglyph-remove'
                    autoTrackingKey={`${dialogTrackingKey}.close`}
                    className='modal-header-close close'
                    onClick={onClose}
                    aria-label='dialog close button'
                />
            }
            body={
                <IframeResizer
                    src={`https://contact-form.rio.cloud/contact?hideTitle=true&opener=${window.location.host}`}
                    checkOrigin={false}
                    className='unstyled min-width-100pct'
                    style={{ height: '600px' }}
                />
            }
        />
    );
};
